module.exports = __webpack_public_path__ + "asset/img/right.cacc5b39.png";